module.exports = __webpack_public_path__ + "GnuMICR.92d2b686a757c4f6fdad.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/GnuMICR.ttf
// module id = ../../../../../src/fonts/GnuMICR.ttf
// module chunks = styles